import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Clock.svg",
  "use": "Clock.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Clock.svg\"><path d=\"M32.01,56.0209a24,24,0,1,1,24-24A24,24,0,0,1,32.01,56.0209Zm9.4961-19.55L34.8683,30.49,33.5139,17.3581a1.5092,1.5092,0,0,0-3,0c-.0182.1759-1.493,14.481-1.512,14.6554a2.3776,2.3776,0,0,0,1.3824,2.4047l9.559,4.46A1.4515,1.4515,0,0,0,41.5065,36.4709Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol